import React, { memo } from 'react';

export const Card = memo(({ children, className = '', ...props }) => (
  <div 
    className={`bg-white rounded-lg shadow border transition-shadow duration-200 hover:shadow-lg ${className}`}
    {...props}
  >
    {children}
  </div>
));

export const CardHeader = memo(({ children, className = '', ...props }) => (
  <div 
    className={`px-6 py-4 ${className}`}
    {...props}
  >
    {children}
  </div>
));

export const CardTitle = memo(({ children, className = '', ...props }) => (
  <h3 
    className={`text-lg font-semibold text-gray-900 ${className}`}
    {...props}
  >
    {children}
  </h3>
));

export const CardContent = memo(({ children, className = '', ...props }) => (
  <div 
    className={`px-6 pb-6 ${className}`}
    {...props}
  >
    {children}
  </div>
));

export default Card;
